/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
// pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;

(function($) {
	isTouch = Modernizr.touchevents;

	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		resizeSidebar();
	};

	var resizeSidebar = function() {
		var parentwidth = $('.fixed-right-auto').closest('.col').width();
		$('.fixed-right-auto').width( parentwidth );
	};

	function $_GET( param ) {
		
		var vars = {};

		window.location.href.replace( location.hash, '' ).replace( 
			/[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
			function( m, key, value ) { // callback
				vars[key] = value !== undefined ? value : '';
			}
		);

		if ( param ) {
			return vars[param] ? vars[param] : null;	
		}
		return vars;
	}
	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
	      ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();

		if (scrollTop > 60) {
			$('html').addClass('is-scrolled');
		}
		else {
			$('html').removeClass('is-scrolled');
		}
	};

	var scrollHandlerOnce = function() {
		var scrollTop = $(window).scrollTop();

		if (scrollTop > 60) {
			$('html').addClass('is-scrolled-once');
		}
		
	};

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function(url) {
		$loader = $('.page-loader');
		$logo   = $('.page-loader__logo');
		$disc   = $('.page-loader__disc');
		
		$loader.addClass('page-loader-active');

		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			TweenMax.fromTo( $loader, 0.2, { opacity: 0 }, { opacity: 1, delay: 0 } )
		]);
		tl.call(function() {
			$(window).scrollTop(0);

			if( !pageAjax ){
				// A la fin de l'anim, on redirige vers la nouvelle URLs
				window.location.href = url;
			}else{
				// mise à jour de la variable qui indique que l'animation est terminée
				showLoaderProgressing  = false;
			}
		});
		tl.play();
	};

	var hideLoader = function() {
		// On lance l'animation de révélation de la page
		$loader = $('.page-loader');
		$disc   = $('.page-loader__disc');
		$logo   = $('.page-loader__logo');

		tl = new TimelineLite();
		tl.pause();
		tl.call(function() {
			initScrollAnimations();
			$loader.removeClass('page-loader-active');
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			TweenMax.to( $loader, 0.2, { opacity: 0 } )
		], [], this, 1);	
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	 ######    ########   ########   
	##    ##   ##         ##    ##   
	##         ##             ##     
	##         ######        ##      
	##         ##           ##       
	##    ##   ##           ##       
	 ######    ##           ##       
	*/
	var formLoader = function(){

		var form           = $( 'div.wpcf7' );
		var container      = $( '.form-container' );
		var inputContainer = $( '.form-container .form-input' );
		var input          = $( '.form-container input, .form-container textarea' );

		var btn       = $( '.form-container input[type="submit"]' );
		var reset     = $( '.form-container #resetForm' );

		btn.on('click', function () {

			$( '.form-container' ).append( "<div class='map-box__loader no-border'></div>" );

			container.removeClass('sent');
			container.addClass('sending no-border ');
			inputContainer.removeClass('error');
		});

		form.on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
			container.removeClass('sending no-border ');
		});

		form.on('wpcf7invalid', function() {
			$( '.map-box__loader' ).remove();
			container.removeClass('map-box__loader no-border ');
			input.each( function() {
				if ( $(this).hasClass('wpcf7-not-valid') ) {
					$(this).closest('.form-input').addClass('error');
				}
			});
		});

		form.on('wpcf7mailsent', function() {
			$( '.map-box__loader' ).remove();
			container.removeClass('map-box__loader no-border ');
			container.addClass('sent');
			reset.click();

			$('.form-input--file').each( function() {
				var $label	 = $( this ).find( 'label span' ),
					labelVal = $( this ).data('label');

				$label.html( labelVal );
				$label.removeClass('filled');
			});

			setTimeout( function() {
				container.removeClass('sent sending');
			}, 2000 );
		});

		reset.on('click', function() {
			inputContainer.removeClass('filled');
			inputContainer.removeClass('active');
			btn.addClass('disabled');

		});

		$('#form_acceptance input[type="checkbox"], #form_acceptance label').on('click', function(e) {
			
			var checkbox = $('#form_acceptance input[type="checkbox"]');

			if ( checkbox.prop('checked') == true ) {
				btn.removeClass('disabled');
			} else {
				btn.addClass('disabled');
			}
		});

		btn.on('click', function() {
			btn.addClass('disabled');

			setTimeout( function() {
				btn.removeClass('disabled');
			}, 1000 );
		});

		input.each(function() {
			var input = $(this);

			if( input.val() !== "" ) {
				input.closest('.form-input').addClass('filled');
				input.closest('.form-input').addClass('active');
			}

			input.on('focus', function() {
				input.closest('.form-input').addClass('active');
			}).on('blur', function() {
				input.closest('.form-input').removeClass('active');

				if( input.val() === "" ) {
					input.closest('.form-input').removeClass('filled');
				} else {
					input.closest('.form-input').addClass('filled');
				}
			});
		});
	};

	$('.form-input--file').each( function() {
		var $input	 = $( this ).find( 'input' ),
			$label	 = $( this ).find( 'label span' ),
			labelVal = $label.html();

		$input.on( 'change', function( e ) {
			var fileName = '';
			// console.log('bim');

			fileName = e.target.value.split( '\\' ).pop();
			if ( fileName ) {
				$label.html( fileName );
				$label.addClass('filled');
			} else {
				$label.html( labelVal );
				$label.removeClass('filled');
			}
		});

		// Firefox bug fix
		$input
		.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
		.on( 'blur',  function(){ $input.removeClass( 'has-focus' ); });
	});



	/*
	##    ##      ###     ##     ##  
	###   ##     ## ##    ##     ##  
	####  ##    ##   ##   ##     ##  
	## ## ##   ##     ##  ##     ##  
	##  ####   #########   ##   ##   
	##   ###   ##     ##    ## ##    
	##    ##   ##     ##     ###     
	*/
	$('.toggle__nav-main').on('click', function() {
		if ( $('html').hasClass('map--is-opened') ) {
			$('html').removeClass('map--is-opened');
		}

		if ( $('html').hasClass('nav-main--is-opened') ) {
			$('html').removeClass('nav-main--is-opened');
		} else {
			$('html').addClass('nav-main--is-opened');
		}
	});

	$('.toggle__map').on('click', function() {
		if ( $('html').hasClass('nav-main--is-opened') ) {
			$('html').removeClass('nav-main--is-opened');
		}
		
		if ( $('html').hasClass('map--is-opened') ) {
			$('html').removeClass('map--is-opened');
		} else {
			$('html').addClass('map--is-opened');
		}
	});


	$('.nav-main__content').on('click', function() {
		$('html').removeClass('nav-main--is-opened');
	});

	$('.nav-main__container').on('click', function(event) {
		event.stopPropagation();
	});

	$('.sidebar--map').on('click', function() {
		$('html').removeClass('map--is-opened');
	});

	$('.map-box').on('click', function(event) {
		 if ( !jQuery(event.target).is('.map-overlay-close') ) {
			event.stopPropagation();
		}
	});
	

	// NAV HOME
	var video = '';
	$('.nav-home__menu-item a').mouseenter(function() {
		$('.video__container:not(.video__container--always-displayed)').removeClass('video--active');
		video = $(this).data('video-id');
		$(video).addClass('video--active');
	});

	$('.nav-home__menu-item a').mouseleave(function() {
		$('.video__container:not(.video__container--always-displayed)').removeClass('video--active');
	});
	
	/*
	 ######    ########      ###     ########    ######    ##     ##  
	##    ##   ##           ## ##    ##     ##  ##    ##   ##     ##  
	##         ##          ##   ##   ##     ##  ##         ##     ##  
	 ######    ######     ##     ##  ########   ##         #########  
	      ##   ##         #########  ##   ##    ##         ##     ##  
	##    ##   ##         ##     ##  ##    ##   ##    ##   ##     ##  
	 ######    ########   ##     ##  ##     ##   ######    ##     ##  
	*/



	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	// Charge la function permettant de gérer le chargement des pages via AJAX
	if( pageAjax ){
		ajaxUrl.init();
	}

	var pageInit = function() {

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$(window).on('scroll', scrollHandlerOnce);
		// $(window).on('scrollEnd', scrollHandlerDebounced);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		// $(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                   // Affiche un 'cache' à la validation d’un form CF7
		resizeSidebar();
		
		/* Autres scripts qui doivent être initialisés */
		// slider.init();
		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ( $( '.editor-text' ).length > 0 ) {
			$( '.editor-text' ).fitVids({
				customSelector: 'iframe[src*="facebook"]'
			});
		}


		// Focus on search box on load
		// var $request = $_GET( 'optisearch' );
		// console.log($request);

		if ( $('.search-box').length > 0 )  {
			$('.search-box input#search').focus();
			// if( $('.search-box input#search').val() !== "" ) $('.search-box').addClass('search-box--filled');
			$('.search-box').addClass('search-box--focused');
		}

		$('input#search').each( function() {
			$(this).on('focus', function(){
				$(this).closest('.search-box').addClass('search-box--focused');
			}).on('blur', function(){
				$(this).closest('.search-box').removeClass('search-box--focused');
				if ( $(this).val() === '' ) {
					$(this).closest('.search-box').removeClass('search-box--filled');
				}
			});
		});

		$( '#coachsearch' ).on( 'keyup', function( e ) {
			var searchValue = $('input[name="optisearch"]').val();

			if ( searchValue === '' ) {
				$('.search-box--focused').removeClass('search-box--filled');
			} else {
				$('.search-box--focused').addClass('search-box--filled');
			}
		});



		// Transmission des liens vers la fonction linkHandler()
		$(document).on('click', '[data-link]', function(e) {
			linkHandler( $(this) );
		}).find('a').click(function(e) {
			e.stopPropagation();
		});

		$('a:not(.cn-button)').click(function(e) {
			e.preventDefault();
			linkHandler( $(this) );
		});

		// Charge la function permettant de gérer le chargement des pages via AJAX
		if( pageAjax ){
			ajaxUrl();
		}
	};

	// Functions à réinitialisées après un chargement de page via ajax
	afterAjax = function(){
		$('.data-mh').matchHeight();
		resizeParallax();
	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

	// Exemple d'utilisation du plugin Mcube Gmaps
	$('.map-box').mcubeGmapsAjax({
		// bounds:            true,  // default: true
		overlay:           true,  // default: true
		zoomControl:       false, // default: false
		streetViewControl: false, // default: true
		fullscreenControl: false, // default: true
		mapTypeControl:    false, // default: true
		styles:            [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
	});


})(jQuery);
